
//
const option = {
  grid: {
    // 关键：把 bottom 调小，直接减少底部空白
    top: 50,    // 顶部留白（可根据需要调整）
    left: 10,   // 左侧留白
    right: 10,  // 右侧留白
    bottom: 0,  // 底部留白！设为0就能紧贴容器底部
    containLabel: true // 自动包含坐标轴标签，避免文字被裁
  },
  // 悬停显示
  tooltip:{
    trigger: 'axis',
    formatter:function(params){
      return params.map(i => {
        return `<div style="display:flex;line-height: 20px;height: 20px;flex-direction: row;align-items: center;">
          <div style="height: 10px;width: 10px;border-radius: 10px;margin-right: 5px;background: ${i.borderColor}"></div>
          <div style="">${i.seriesName}: ${i.data}</div>
        </div>`
      }).join("")
    },
  },
  // 横坐标
  xAxis: {
    type: 'category',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] // 标题
  },
  // 颜色-内容
  legend: {
    right: 10,
    top: 0,
    selectedMode: false,
  },
  // 纵坐标
  yAxis: {
    type: 'value',
    minInterval: 1,
  },
  series: [
    {
      name: "1",    
      type: 'line',
      data: [120, 200, 150, 80, 70, 110, 130], 

      symbol: 'circle',      // 点形状：圆形
      symbolSize: 8,         // 点大小
      lineStyle: {
        color: '#1890ff', // 折线颜色
        width: 2
      },
      // 点的颜色
      itemStyle: {
        color: '#000',                // 点中心颜色
        borderColor: '#409EFF',       // 点边框颜色
        borderWidth: 2                // 点边框宽度
      },
      
    }
  ]
};
/*
  data = Array({
    name: "",
    data: [],
    color:"",
  })
*/

// 根据Max - Min 的位数 - 2的10次方(最小取10), 恒定切成5个间隔
export function getMinMaxInterval(list){
  // 获取最大最小值
  const sortList = [...list].sort((a,b) => a - b);
  const min = sortList[0];
  const max = sortList[list.length - 1];
  // 小于10的特殊处理
  if(max <= 10){
    return {
      min: 0,
      max: 10,
      interval: 2,
    }
  }
  // Max - Min => 1/10
  const pow = Math.pow(10, Math.max(String(max - min).length - 2, 1));
  const re_max = Math.ceil(max/pow)*pow;
  let re_min = Math.max(Math.floor(min/pow) - 5, 0)*pow; // 如果刻度大于0，则至少给最小值留有10%的高度
  return {
    min: re_min,
    max: re_max,
    interval: (re_max - re_min)/5
  }
}
export function getLine(xData, data){
  return {
    ...option,
    xAxis:{
      ...option.xAxis,
      data: xData,
    },
    yAxis: data.map((i, index) => {
      var res = {
        type: 'value',
        name: i.name,
        scale: true,
        axisLine: { lineStyle: { color: i.color } },
        alignTicks: true,
        ...getMinMaxInterval(data[index].data),
      }
      if(index > 0){
        return {
          ...res,
          position: 'right', // 放右边
        }
      }
      return res
    }),
    series: data.map((i, index) =>{
      return {
        ...option.series[0],
        yAxisIndex: index,
        name: i.name,
        data: i.data,
        lineStyle:{
          color: i.color,
          width: 2,
        },
        itemStyle:{
          color: "#000",
          borderColor: i.color,
          borderWidth: 2,
        },
      }
    })
  }
}